import { SlotType } from "../../models/slot"
import type { GlobalUserSurveySlot } from "../../models/globalUserSurvey"
import { testId } from "../../utility/tests/testId/surveys"

export const getInputTestId = (slot: GlobalUserSurveySlot, inputPrefix?: string) => {
    if (inputPrefix) {
        return `${inputPrefix}-${slot.SlotId}`
    }

    if (slot.Type === SlotType.Dictionary) {
        return testId.dictionarySlot
    }

    if (slot.IncreasedSize) {
        return testId.increasedSlotInput
    }

    return testId.slotInput
}
